import {inject} from '@angular/core';
import {CanActivateChildFn, CanActivateFn, Router} from '@angular/router';

import {of, switchMap} from 'rxjs';
import {AuthService} from "@shared/services/auth.service";

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (
    route,
    state
) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(AuthService)
        .isSignedIn()
        .pipe(
            switchMap((authenticated) => {
                // If the user is authenticated...
                if (authenticated && !['/anmelden', '/registrieren', '/forgot-password'].includes(state?.url)) {
                    return of(router.parseUrl(''));
                }

                // Allow the access
                return of(true);
            })
        );
};
